<template>
  <div>
    <div>
      <Visualizar />
    </div>
    <b-row>
      <b-col class="one">
        <Help
          :title="title"
          :text="text"
          :text_Two="text_Two"
          :text_One="text_One"
        />
      </b-col>
      <b-col v-if="readOnly"></b-col>
      <b-col v-else class="btn-direction-flex">
        <b-button
          pill
          variant="primary"
          class="btn-one"
          v-if="userPermissions"
          @click="guardarBorrador"
        >
          Guardar como borrador
        </b-button>
        <b-button
          pill
          variant="primary"
          class="btn-two"
          v-if="userPermission"
          @click="guardarFinalizado"
        >
          Guardar y finalizar
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="title">
        <h5>Equidad de Género</h5>
      </b-col>
    </b-row>

    <b-row v-if="userPermissions" class="Checkbox-form">
      <b-form-checkbox
        style="display:flex;   justify-content: flex-end; "
        v-model="checked"
        name="check-button"
        switch
      >
        <span class="span" v-if="checked"> No Aplica</span>
        <span class="span" v-else>No Aplica</span>
      </b-form-checkbox>
    </b-row>

    <b-row>
      <div v-if="checked">
        <AlertError />
      </div>
    </b-row>

    <b-row>
      <div v-if="!checked">
        <TableOne :cosoTablaUno="cosoTablaUno" :readOnly="readOnly" />
      </div>
    </b-row>

    <b-row>
      <div v-if="!checked">
        <Table
          :readOnly="readOnly"
          :addItemList="addItemList"
          :itemList="itemList"
          :removeItem="removeItem"
        />
      </div>
    </b-row>
  </div>
</template>

<script>
import Visualizar from "../../../../components/button/escritorio/Visualizar.vue";
import Help from "../../../../components/tools/Modal";
import Table from "./content/Table.vue";
import axios from "axios";
import Swal from "sweetalert2";
import TableOne from "./content/TableOne.vue";


import { showAlert } from "../../../../components/tools/utils";

export default {
  components: {
    Visualizar,
    Help,
    Table,
    TableOne,
  },
  data() {
    return {
      itemList: [],
      anio: process.env.VUE_APP_ANIO,
      data: null,
      nombre: "genero",
      checked: false,
      itemData: [],
      cosoTablaUno: {
        diagnosticoInstitucional: "",
        politicaInstitucional: "",
        protocolos: "",
        capacitacionBasico: "",
        capacitacionAvanzado: "",
        comunicaciones: "",
        politicasElaboradas: "",
        legislacion: "",
        estudios: "",
      },
      datosUser: null,

      title: "Equidad de Género",
      text:
        "Presentar brevemente los resultados alcanzados en 2020 considerando información objetiva respaldada en valores cuantitativos, o hechos específicos, y cualitativos. Precisando el efecto en los usuarios/as, beneficiarios/as, ciudadanos/as.",
      text_Two:
        "Cuadro 1: En aquellos compromisos que no fueron posibles implementar las medidas, señalar las causas y las medidas adoptadas (si las hay) para 2020. En medidas no comprometidas el año 2020, señalar No Aplica.",
      text_One:
        "Cuadro 2: Señalar alguna otra iniciativa en materia de igualdad de género que el Servicio quiera relevar. Por ejemplo: Norma Chilena 3262 de igualdad de género y conciliación de la vida laboral, familiar y personal; Instructivo Presidencial Maltrato, Acoso Laboral y Acoso Sexual; orgánica de género institucional; presupuesto para género; otros.",
    };
  },
  props: ["readOnly", "userPermissions", "userPermission"],

  methods: {
    addItemList: function() {
      const toAddObj = {
        medida: "",
        resultados: "",
      };
      this.itemList.push(toAddObj);
    },
    removeItem: function(index) {
      const pos = this.itemList.indexOf(index);

      this.itemList.splice(pos, 1);
    },
    buildData: function(type) {
      return {
        nombre: this.nombre,
        elaboracion: type,
        data: {
          aplica: this.checked,
          content: this.itemList,
          table: this.cosoTablaUno,
        },
        anio: process.env.VUE_APP_ANIO,
        idServicio: this.$route.params.idServicio,
      };
    },
    guardarBorrador: async function() {
      const toSend = this.buildData("borrador");
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/`,
          toSend,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );
        showAlert({
          icon: "success",
          text: "Guardado como Borrador Exitoso",
          timerProgressBar: true,
          timer: 3000,
        });
        console.log(res);
      } catch (error) {
        if (error.response.status === 422) {
          const toSend = {
            nombre: this.nombre,
            elaboracion: "borrador",
            data: {
              aplica: this.checked,
              content: this.itemList,
              table: this.cosoTablaUno,
            },
            anio: process.env.VUE_APP_ANIO,
          };

          await axios.put(
            `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/`,
            toSend,
            {
              headers: {
                Authorization: `JWT ${localStorage.getItem("userToken")}`,
              },
            }
          );

          showAlert({
            icon: "success",
            text: "Guardado como Borrador Exitoso",
            timerProgressBar: true,
            timer: 3000,
          });
        } else {
          console.log(error);
          showAlert({
            icon: "error",
            text: error.response.data[Object.keys(error.response.data)[0]],
            timerProgressBar: true,
            timer: 3000,
          });
        }
        console.log(error);
      }
    },
    guardarFinalizado: async function() {
      const toSend = this.buildData("finalizado");

      Swal.fire({
        title: "Guardar y Finalizar",
        text: "¿Desea guardar los datos?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Confirmar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const res = await axios.post(
              `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/`,
              toSend,
              {
                headers: {
                  Authorization: `JWT ${localStorage.getItem("userToken")}`,
                },
              }
            );  
            showAlert({
              icon: "success",
              text: "Guardado y finalizado exitosamente.",
              timerProgressBar: true,
              timer: 3000,
            });
            console.log(res);
          } catch (error) {
            if (error.response.status === 422) {
              const toSend = {
                nombre: this.nombre,
                elaboracion: "finalizado",
                data: {
                  content: this.itemList,
                  table: this.cosoTablaUno,
                  aplica: this.checked,
                },
                anio: process.env.VUE_APP_ANIO,
              };

              await axios.put(
                `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/`,
                toSend,
                {
                  headers: {
                    Authorization: `JWT ${localStorage.getItem("userToken")}`,
                  },
                }
              );

              showAlert({
                icon: "success",
                text: "Guardado y finalizado exitosamente.",
                timerProgressBar: true,
                timer: 3000,
              });
            } else {
              console.log(error);
              showAlert({
                icon: "error",
                text: error.response.data[Object.keys(error.response.data)[0]],
                timerProgressBar: true,
                timer: 3000,
              });
            }
            this.$router.push({
              name: "buttons",
              params: { idUsuario: this.usuario.id },
            });
          }
        }
      });
    },
    obtenerContenido: async function() {
      try {
        const obj = {
          anio: process.env.VUE_APP_ANIO,
          nombre: "genero",
        };
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/?anio=${obj.anio}&nombre=genero`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );

        res.data.info= res.data.info || {}
        this.checked = res.data.info.aplica || false;
        
        this.checked = res.data.info.aplica;
        
        if (res.data.info.content) {
          this.itemList = res.data.info.content;
        }
        if (res.data.info.table) {
          this.cosoTablaUno = res.data.info.table;
        }
      } catch (error) {
        console.log(error);
      }
    },
 

  },
  mounted() {
    this.obtenerContenido();
 
  },
};
</script>

<style scoped>
.row {
  margin: 0;
}
.span {
  font-size: 18px;
  color: #052333;
  font-weight: 600;
  display: grid;
  top: -10px;
}
.btn-one {
  margin-right: 20px;
}

.btn-direction-flex {
  text-align: end;
}

.title {
  margin-top: 20px;
  text-align: center;
  color: #052333;
}

th {
  text-align: left !important;
  font-size: 14px !important ;
}

td {
  text-align: center;
}

.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  background-color: var(--bs-table-bg);
  border-bottom-width: 1px;
  box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);
  text-align: left;
}

.div {
  width: 96%;
  height: 26px;
  position: relative;
  left: 3px;
  background-color: #fff;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  width: 50%;
  padding: 5px;
  text-align: left !important;
  font-size: 13px;
}

td {
  text-align: left;
  font-size: 16px;
}
@media screen and (max-width: 784px) {
  .btn-one {
    font-size: 11px;
    margin-right: 5px;
  }
  .btn-two {
    font-size: 11px;
  }
}

@media screen and (max-width: 569px) {
  .btn-one {
    font-size: 10px;
    margin-right: 5px;
    width: 90px;
  }
  .btn-two {
    font-size: 10px;
    width: 90px;
  }
}

@media screen and (max-width: 417px) {
  .one {
    display: none;
  }
  .btn-one {
    font-size: 10px;
    margin-right: 5px;
    width: 90px;
    margin-bottom: 15px;
  }
  .btn-two {
    font-size: 10px;
    width: 90px;
    position: relative;
    top: -6px;
  }
  .btn-direction-flex {
    text-align: start;
    margin-left: 30px;
  }
}
</style>
